/* eslint-disable no-dupe-keys */
module.exports = {
    livechat: {
        externalAvailabilityFunctionName: "isChatAvailable",
        defaultOperatorName: "Representative",
        maxInputLength: 4000,
        filterCurrentChatMessagesOnReload: false, //should only be enabled in chat transcript module
        surveyUrlFormat: "{0}ci/documents/detail/5/{1}/12/{2}/6/223/7/{3}",
        textConstants: {
            // end chat link
            endChatLinkText: "End Live Chat",
            endChatLinkToolTip: "Click to end Live Chat",

            // title bar text
           bannerText: "Live Chat",

            // connecting/disconnecting from chat banners
            chatBannerConnectingPrimary: "Connecting to",
            chatBannerConnectingSecondary:  "Live Chat",
            chatBannerConnectingAdditional: "",
            chatBannerConnectedPrimary: "Connected to",
            chatBannerConnectedSecondary: "Live Chat Operator: {0}",
            chatBannerConnectedAdditional: "",
            chatBannerUserDisconnectedPrimary: "Returning to",
            chatBannerUserDisconnectedSecondary:"ASK JULIE",
            chatBannerUserDisconnectedAdditional:"Customer Ended Live Chat",
            chatBannerOperatorDisconnectedPrimary: "Returning to",
            chatBannerOperatorDisconnectedSecondary: "ASK JULIE",
            chatBannerOperatorDisconnectedAdditional: "Operator Ended Live Chat",

            // response constants
            responseTitleText:  "{0} said:",
            sentMessageReceiveText: "Message received, operator responding shortly...",
            inputPlaceholderText: "Please wait...",
            
            // Live chat foundation
            chatBannerUserDisconnectPrimary: "Returning to",
            chatBannerUserDisconnectSecondary: "Intelligent Virtual Assistant",
            chatBannerUserDisconnectAdditional: "Customer Ended Live Chat",
            chatBannerOperatorDisconnectPrimary:"Returning to",
            chatBannerOperatorDisconnectSecondary:  "Intelligent Virtual Assistant",
            chatBannerOperatorDisconnectAdditional:"Agent Ended Live Chat",
            chatBannerSystemDisconnectPrimary: "Returning to",
            chatBannerSystemDisconnectSecondary: "Intelligent Virtual Assistant",
            chatBannerSystemDisconnectAdditional: "System Ended Live Chat",
            chatBannerNotEngagedDisconnectPrimary: "Returning to",
            chatBannerNotEngagedDisconnectSecondary: "Intelligent Virtual Assistant",
            chatBannerNotEngagedDisconnectAdditional: "System Ended Live Chat",
            //end chat link
            errorResponse:  "Uh oh, looks like we were unable to process your request. Please try again.",
            //input box
            pendingPlaceholder: "Please wait...",
            //typing notification
            typingNotificationText: "{0} typing...",
        },
        error: {
            maxErrorCountAllowed: 5,
        },
        maxInputLength: 1000,
        messageOrigin: {
            operator: 'Operator',
            operatorJoined: 'Operator-Joined',
            operatorLeft: 'Operator-Left',
            operatorTyping: 'Operator-Typing',
            sessionEnd: 'Session-End',
            system: 'System',
            user: 'User',
        },
        messageSource: 'LiveChat',
        reportingEventConstants: {
            terminateSessionEventName: 'TerminateSession',
            userTypingEventName: 'Typing',
        },
        sessionEndReason: {
            agent: 'Agent',
            error: 'Error',
            notEngaged: 'NotEngaged',
            user: 'User',
        },
        sessionState: {
            offline: 'Offline',
            queued: 'Queued',
            online: 'Online',
        },
        timeouts: {
            operatorTypingDelayMS: 3000,
        },
        liveChatStartAction: 'LiveChatStart',
    },
};



// WEBPACK FOOTER //
// ./settings/live-chat.js